import { createFileRoute } from '@tanstack/react-router';

import { ensureVirtualTourByIdQueryData } from '@/features/estate-media/api/virtual-tour';

export const Route = createFileRoute(
  '/_authenticated/_nosidebar-layout/estates/$estateId/media/virtual-tour/$tourId/'
)({
  component: RouteComponent,
});

function RouteComponent() {
  return ensureVirtualTourByIdQueryData;
}
